module.exports = __webpack_public_path__ + "static/media/spicyLevel0.4ef108db.svg";